<section>
  <div class="progress">
    @for (step of purchaseProcessService.experimentalSteps; track step) {
      <div class="progress-item">
        @if (isInactiveCurrentStep(step)) {
          <div class="progress-item-box" [ngClass]="currentStepClass(step)">
            <div class="step">{{step.step}}</div>
            <div class="label">{{step.label}}</div>
            <div class="mobile-label">{{ step.mobileLabel}}</div>
          </div>
        }
        @if (isActiveStep(step)) {
          <div class="progress-item-box active">
            <a [routerLink]="step.path" [queryParams]="step.queryParams" [ngClass]="currentStepClass(step)">
              <div class="step"><img src="../../../assets/img/features/check-icon.svg" alt=""></div>
              <div class="label">{{step.label}}</div>
            </a>
          </div>
        }
      </div>
    }
  </div>
</section>
